import Dropdown from "../../../components/dropdown/dropdown";
import { paramBuyerListingPeriod, paramsBuyerListingValues, titleOptionsDropdown } from "../../../utils/constants";
import { useState } from "react";
import { ICountMetrics } from "./buyerListingTypes";

interface BuyerListingDropdownProps {
  counts: ICountMetrics;
  setSelectedMetric: (value: string) => void;
  setGetParams: (params: any) => void;
  getParams: any;
}

interface dropDownOption {
  label: string;
  secondaryLabel: number;
  value: string;
}

export const BuyerListingDropdown: React.FC<BuyerListingDropdownProps> = ({
  counts,
  setSelectedMetric,
  setGetParams,
  getParams,
}) => {
  const getPeriod = getParams.get(paramBuyerListingPeriod);

  const defaultOption = {
    label: titleOptionsDropdown.allBuyers,
    secondaryLabel: counts.allBuyers.count,
    value: paramsBuyerListingValues.allBuyers,
  };

  const arrayOptions = [
    defaultOption,
    {
      label: titleOptionsDropdown.sevenDays,
      secondaryLabel: counts.newSalesLast7Days.count || 0,
      value: paramsBuyerListingValues.newSalesLast7Days,
    },
    {
      label: titleOptionsDropdown.twoWeeks,
      secondaryLabel: counts.closingsIn14Days.count,
      value: paramsBuyerListingValues.closingsIn14Days,
    },
    {
      label: titleOptionsDropdown.thisMonth,
      secondaryLabel: counts.closingsThisMonth.count,
      value: paramsBuyerListingValues.closingsThisMonth,
    },
    {
      label: titleOptionsDropdown.thirtyDays,
      secondaryLabel: counts.closingsIn30Days.count,
      value: paramsBuyerListingValues.closingsIn30Days,
    },
    {
      label: titleOptionsDropdown.sixtyDays,
      secondaryLabel: counts.closingsIn60Days.count,
      value: paramsBuyerListingValues.closingsIn60Days,
    },
    {
      label: titleOptionsDropdown.weeklyUpdateHomesites,
      secondaryLabel: counts.weeklyUpdate.count,
      value: paramsBuyerListingValues.weeklyUpdate,
    },
    {
      label: titleOptionsDropdown.closedHomesites,
      secondaryLabel: counts.closeHomeSites.count,
      value: paramsBuyerListingValues.closedHomes,
    },
    {
      label: titleOptionsDropdown.ecoeMismatch,
      secondaryLabel: counts.ecoeMismatch.count,
      value: paramsBuyerListingValues.ecoeMismatch,
    },
  ];

  const getOptionByFilter = arrayOptions.filter((item: dropDownOption) => item.value === getPeriod)[0];
  const [dropdownOption, setDropdownOption] = useState(getOptionByFilter ? getOptionByFilter : defaultOption);

  return (
    <Dropdown
      options={arrayOptions}
      onChange={(item: any) => {
        setSelectedMetric(item.value);
        setDropdownOption(item);
        setGetParams((params: any) => {
          params.set(paramBuyerListingPeriod, item.value);
          return params;
        });
      }}
      placeholder=""
      selectedOption={dropdownOption}
    />
  );
};
